import { FunctionComponent } from "react";
import { StyledIcon, StyledIconCell } from "./icon-cell.styles";
import { faPen, IconType } from "components/icon-library";

interface TableIconCellProps {
  disabled: boolean;
  icon?: IconType;
  onClick?: () => Promise<void>;
}

const TableIconCell: FunctionComponent<TableIconCellProps> = ({
  disabled,
  icon = faPen,
  onClick,
}) => {
  const handler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <StyledIconCell>
      <StyledIcon icon={icon} $disabled={disabled} onClick={handler} />
    </StyledIconCell>
  );
};

export default TableIconCell;
